import authorApiFactory from '../../modules/author/authorApi';

/* Actions */
import {
  getAuthorsActionCreators,
} from '../actions/authorActions';

/* Utils */
import {
  generateDefaultAsyncSaga,
  generateDefaultAsyncWatcher,
} from '../core/reduxUtils';

function authorSagasFactory({storefrontApiClient}) {
  const authorApi = authorApiFactory(storefrontApiClient);

  const getAuthorsSagas = generateDefaultAsyncSaga(
    authorApi.getAuthors,
    getAuthorsActionCreators,
    payload => [
      payload.params,
    ]
  );

  const watchGetAuthors = generateDefaultAsyncWatcher(
    'GET_AUTHORS',
    getAuthorsSagas
  );

  const authorSagas = [
    watchGetAuthors(),
  ];

  return authorSagas;
}

export default authorSagasFactory;
